export const cardMigrationExternal = {
    targetClientId: '',
};
